import Modal from "react-modal";
import "../../styling/Modal.css";
import axios from "axios";
import { useState } from "react";
import { useSelector } from "react-redux";
import Select, { components } from "react-select";

const CreateBookingModal = ({ isModalOpen, closeModal }) => {
  const [eventDate, setEventDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [clientEmail, setClientEmail] = useState("");
  const [eventName, setEventName] = useState("");
  const [errors, setErrors] = useState({});
  const [eventType, setEventType] = useState("");
  const [eventRefer, setEventRefer] = useState("");
  const [location, setLocation] = useState("");
  const [endTime, setEndTime] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);

  const options = [
    { value: "wedding", label: "Wedding" },
    { value: "corporate", label: "Corporate" },
    { value: "birthday", label: "Birthday" },
    { value: "others", label: "Others" },
  ];

  const referalOptions = [
    { value: "friends", label: "Friends or Family" },
    { value: "website", label: "Website" },
    { value: "socialMedia", label: "Social Media" },
    { value: "other", label: "Other" },
  ];

  const customStyles = {
    control: (base) => ({
      ...base,
      border: "1px solid #D9D9D9",
      borderRadius: "3px",
      boxShadow: "none",
      height: "35px",
      paddingBottom: "10px",
      fontSize: "15px",
      width: "100%",
    }),
  };

  const user = useSelector((state) => state.auth.user);
  const businessId = user.businessId;

  const HandleAddEvent = async () => {
    setLoading(true);
    let newErrors = {};

    if (!name) newErrors.name = " Name is required";
    if (!clientEmail) {
      newErrors.clientEmail = " Email is required";
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(clientEmail)) {
        newErrors.clientEmail = " Please enter a valid email address";
      }
    }
    if (!phone) {
      newErrors.phone = " Phone is required";
    } else {
      const phoneRegex = /^[0-9]{10}$/; 
      if (!phoneRegex.test(phone)) {
        newErrors.phone = " Please enter a valid 10-digit phone number";
      }
    }
    if (!eventName) newErrors.eventName = " Event name is required";
    if (!eventType) newErrors.eventType = " Event type is required";
    if (!eventRefer) newErrors.eventRefer = " Referral source is required";
    if (!eventDate) newErrors.eventDate = " Date is required";
    if (!startTime) newErrors.startTime = " Start time is required";
    if (!endTime) newErrors.endTime = " End time is required";
    if (!location) newErrors.location = " Location is required";

    // Date check
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const selectedDate = new Date(eventDate);

    if (eventDate && selectedDate < today) {
      newErrors.eventDate = " Event date cannot be before today";
    }

    // Time check
    if (startTime && endTime && endTime <= startTime) {
      newErrors.endTime = " End time must be after start time";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setLoading(false);
      return;
    }

    setErrors({}); 
    try {
      const combinedStartDateTime = new Date(`${eventDate}T${startTime}`);
      const combinedEndDateTime = new Date(`${eventDate}T${endTime}`);

      // 1. Check if client exists
      const checkClientRes = await axios.post(
        `${process.env.REACT_APP_API_URL}/client/client-exists`,
        { email: clientEmail },
        { withCredentials: true }
      );

      const clientExists = checkClientRes.data.data.exists;

      // 2. If client doesn't exist, create one
      if (!clientExists) {
        await axios.post(
          `${process.env.REACT_APP_API_URL}/manual-client-user/onboard`,
          {
            name,
            email: clientEmail,
            phone,
            businessId,
          },
          { withCredentials: true }
        );
      }

      // 3. Create the manual event
      await axios.post(
        `${process.env.REACT_APP_API_URL}/create-manual-event`,
        {
          businessId,
          eventDate,
          eventName,
          startTime: combinedStartDateTime,
          endTime: combinedEndDateTime,
          clientEmail,
          status: "pending",
          type: "manual",
          eventType,
          eventRef: eventRefer,
          address: location,
        },
        { withCredentials: true }
      );

      alert("Event successfully created");
      closeModal();
    } catch (err) {
      console.error(err);
      setErrors(err?.response?.data || "Something went wrong");
    } finally {
      setLoading(false); 
    }
  };

  const modalContent = (
    <div>
      <button className="close-button" onClick={closeModal}>
        &#10005;
      </button>
      <form>
        <div className="form-fields">
          <div className="form-field">
            <label htmlFor="clientName">Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            {errors.name && <p style={{ color: "red", fontSize: "12px" }}>{errors.name}</p>}
          </div>

          <div className="form-field">
            <label htmlFor="clientEmail">Email</label>
            <input
              type="text"
              id="clientEmail"
              name="clientEmail"
              value={clientEmail}
              onChange={(e) => setClientEmail(e.target.value)}
            />
            {errors.clientEmail && <p style={{ color: "red", fontSize: "12px" }}>{errors.clientEmail}</p>}
          </div>

          <div className="form-field">
            <label htmlFor="phone">Phone</label>

            <input
              type="text"
              id="phone"
              name="phone"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
            {errors.phone && <p style={{ color: "red", fontSize: "12px" }}>{errors.phone}</p>}

          </div>

          <div className="form-field">
            <label htmlFor="eventnName">Name of your Event</label>
            <input
              type="text"
              id="eventName"
              name="eventName"
              value={eventName}
              onChange={(e) => setEventName(e.target.value)}
            />
            {errors.eventName && <p style={{ color: "red", fontSize: "12px" }}>{errors.eventName}</p>}

          </div>

          <div className="form-field">
            <label htmlFor="eventType">Event Type</label>
            <Select
              options={options}
              styles={customStyles}
              components={{
                IndicatorSeparator: () => null,
              }}
              placeholder=""
              name="eventType"
              id="eventType"
              onChange={(selectedOption) => setEventType(selectedOption.value)}
              value={options.find((option) => option.value === eventType)}
            />
            {errors.eventType && <p style={{ color: "red", fontSize: "12px" }}>{errors.eventType}</p>}

          </div>

          <div className="form-field">
            <label htmlFor="referralSource">Reffered By</label>
            <Select
              options={referalOptions}
              styles={customStyles}
              components={{
                IndicatorSeparator: () => null,
              }}
              placeholder=""
              name="referralSource"
              id="referralSource"
              onChange={(selectedOption) => setEventRefer(selectedOption.value)}
              value={referalOptions.find(
                (option) => option.value === eventRefer
              )}
            />
            {errors.eventRefer && <p style={{ color: "red", fontSize: "12px" }}>{errors.eventRefer}</p>}

          </div>

          <div className="form-field">
            <label htmlFor="bookingDate">Choose a Date</label>

            <input
              type="date"
              id="bookingDate"
              name="bookingDate"
              value={eventDate}
              onChange={(e) => setEventDate(e.target.value)}
            />
            {errors.eventDate && <p style={{ color: "red", fontSize: "12px" }}>{errors.eventDate}</p>}

          </div>

          <div className="form-field">
            <label htmlFor="bookingTime">What time is the event?</label>

            <div style={{ display: "flex", gap: "15px" }}>
              <input
                type="time"
                id="bookingTime"
                name="bookingTime"
                value={startTime}
                onChange={(e) => setStartTime(e.target.value)}
                style={{ width: "50%" }}
              />
              {errors.startTime && <p style={{ color: "red", fontSize: "12px" }}>{errors.startTime}</p>}

              <input
                type="time"
                id="bookingTime"
                name="bookingTime"
                value={endTime}
                onChange={(e) => setEndTime(e.target.value)}
                style={{ width: "50%" }}
              />
              {errors.endTime && <p style={{ color: "red", fontSize: "12px" }}>{errors.endTime}</p>}

            </div>
          </div>

          <div className="form-field">
            <label htmlFor="location">Where is your event located?</label>
            <input
              type="text"
              id="location"
              name="location"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
            />
            {errors.location && <p style={{ color: "red", fontSize: "12px" }}>{errors.location}</p>}

          </div>
        </div>
      </form>
      <button
        type="button"
        onClick={HandleAddEvent}
        disabled={loading}
        style={{
          background:
            "transparent linear-gradient(90deg, #1C1154 0%, #260F99 100%) 0% 0% no-repeat padding-box",
          borderRadius: "3px",
          width: "100%",
          color: "#fff",
          padding: "10px",
          fontSize: "15px",
          cursor: loading ? "not-allowed" : "pointer",
          opacity: loading ? 0.7 : 1,
        }}
      >
        {loading ? "Booking..." : "Book your Booth"}

      </button>
    </div>
  );

  return (
    <div>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        ariaHideApp={false}
        className="custom-modal"
        style={{
          content: {
            top: "53%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#fff",
            padding: "30px",
            borderRadius: "12px",
            width: "60%",
            maxWidth: "600px",
            height: "80vh",
            overflowY: "auto",
            boxShadow: "0 4px 16px rgba(0, 0, 0, 0.2)",
          },
        }}
      >
        <div>
          <h2 style={{ fontWeight: "bold", fontSize: "20px" }}>
            Create New Event
          </h2>
          {modalContent}
        </div>
      </Modal>
    </div>
  );
};

export default CreateBookingModal;
